import { assistantIdentity, type AssistantSettings } from "@baton/api";
import { keys, type Runtime } from "@baton/core";
import { queryOptions } from "@tanstack/react-query";

/**
 * The one assistant read the shell makes before the panel's chunk loads (019 `contracts/http-api.md`
 * § Frontend data requirements, Rail button and panel host): `is_enabled` and `surfaces.web_text`, so
 * the rail's tile is drawn only where the panel can open. It lives apart from `queries.ts` so the
 * shell's entry carries this operation alone and not the thread and turn operations the panel reads.
 */
export function assistantSettingsQuery(runtime: Runtime, ws: string) {
  return queryOptions({
    queryKey: keys.assistantSettings(ws),
    queryFn: async ({ signal }): Promise<AssistantSettings> => (await assistantIdentity.settings(runtime.signedIn, { params: { ws }, signal })).data,
  });
}
